"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageKeys = /** @class */ (function () {
    function MessageKeys() {
        throw new Error('Illegal state');
    }
    MessageKeys.REPORTING_DESIGNER_NEW = 'reporting_designer_new';
    MessageKeys.REPORTING_DESIGNER_DATA = 'reporting_designer_data';
    MessageKeys.REPORTING_DESIGNER_NUMBER = 'reporting_designer_number';
    MessageKeys.REPORTING_DESIGNER_DATE = 'reporting_designer_date';
    MessageKeys.REPORTING_DESIGNER_DATETIME = 'reporting_designer_datetime';
    MessageKeys.REPORTING_DESIGNER_TEXT = 'reporting_designer_text';
    MessageKeys.REPORTING_DESIGNER_MONEY = 'reporting_designer_money';
    MessageKeys.REPORTING_DESIGNER_BOOLEAN = 'reporting_designer_boolean';
    return MessageKeys;
}());
exports.MessageKeys = MessageKeys;
//# sourceMappingURL=message-keys.js.map